import { Form } from "antd";
import type { DescriptionsProps } from "antd";
import type { Rule } from "antd/es/form";
import type { ReactNode } from "react";

type DescriptionsItemType = NonNullable<DescriptionsProps["items"]>[number];

export interface FieldConfig {
  key: string;
  label: string;
  editable?: boolean;
  span?: number;
  input?: ReactNode;
  rules?: Rule[];
  dataKey?: string;
  /** antd Form.Item valuePropName — set "checked" for boolean inputs like Switch. */
  valuePropName?: string;
  format?: (value: any) => ReactNode;
}

export function renderFields(
  fields: FieldConfig[],
  data: Record<string, any> | null,
  editing: boolean,
): DescriptionsItemType[] {
  return fields.map((field) => {
    const dataKey = field.dataKey ?? field.key;
    return {
      key: field.key,
      label: field.label,
      span: field.span,
      children:
        editing && field.editable ? (
          <Form.Item
            name={field.key}
            noStyle
            rules={field.rules}
            valuePropName={field.valuePropName}
          >
            {field.input}
          </Form.Item>
        ) : (
          (field.format?.(data?.[dataKey]) ?? data?.[dataKey])
        ),
    };
  });
}
